module.exports = __webpack_public_path__ + "img/courrier-numerisation.3e3b0422.svg";